/*
 * App Actions
 *
 * Actions change things in your application
 * Since this boilerplate uses a uni-directional data flow, specifically redux,
 * we have these actions which are the only way your application interacts with
 * your application state. This guarantees that your state is up to date and nobody
 * messes it up weirdly somewhere.
 *
 * To add a new Action:
 * 1) Import your constant
 * 2) Add a function like this:
 *    export function yourAction(var) {
 *        return { type: YOUR_ACTION_CONSTANT, var: var }
 *    }
 */

import {
  UPDATE_USER,
  UPDATE_PATIENT_FORM_LINKING_STATUS,
  REGISTER_SOCKET,
  ON_SOCKET_MESSAGE,
  ON_SOCKET_TYPING_START,
  ON_SOCKET_TYPING_STOP,
  ON_SOCKET_PROVIDER_ARRIVED,
  EMIT_SOCKET_TYPING,
  ON_SOCKET_ACTIVITY,
} from './constants';

export function updateUser(user) {
  return {
    type: UPDATE_USER,
    user,
  };
}

export function updatePatientFormLinkingStatus(status) {
  return {
    type: UPDATE_PATIENT_FORM_LINKING_STATUS,
    status,
  };
}

export function registerSocket(user) {
  return {
    type: REGISTER_SOCKET,
    user,
  };
}

export function onSocketMessage(message) {
  return {
    type: ON_SOCKET_MESSAGE,
    message,
  };
}

export function onSocketTypingStart(data) {
  return {
    type: ON_SOCKET_TYPING_START,
    data,
  };
}

export function onSocketTypingStop(data) {
  return {
    type: ON_SOCKET_TYPING_STOP,
    data,
  };
}

export function onSocketProviderArrived(data) {
  return {
    type: ON_SOCKET_PROVIDER_ARRIVED,
    data,
  };
}

export const onSocketActivity = (data) => ({
  type: ON_SOCKET_ACTIVITY,
  data,
});

/**
 * Emit typing
 */
export function emitTyping(payload) {
  return {
    type: EMIT_SOCKET_TYPING,
    payload,
  };
}
